import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import api from "./setupAxios";
import { useAuth } from "./context/authContext";

export default function Login() {
  const [user, setUser] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [cargando, setCargando] = useState(false);
  const { login } = useAuth();
  const nav = useNavigate();

  const enviar = async (e) => {
    e.preventDefault();
    setError("");
    setCargando(true);
    try {
      const { data } = await api.post("/login", { user, password });
      if (!data.ok) {
        setError(data.error || "No se pudo iniciar sesión");
        setCargando(false);
        return;
      }
      login({
        user: data.user,
        access_token: data.access_token,
        refresh_token: data.refresh_token,
      });
      // navega según el rol
      nav(data.user?.tipo === "personal" ? "/rutas" : "/operar", {
        replace: true,
      });
    } catch (err) {
      const msg =
        err.response?.data?.error || "Usuario o contraseña incorrectos";
      setError(msg);
      setCargando(false);
    }
  };

  return (
    <div style={styles.fondo}>
      <div style={styles.container}>
        <img src="/logo_ch_llaves-512.png" alt="Campus Home" style={styles.logo} />
        <h2 style={styles.title}>Iniciar sesión</h2>
        <form onSubmit={enviar} style={styles.form}>
          <input type="text" placeholder="Usuario" autoComplete="username" autoCapitalize="none" value={user} onChange={(e) => setUser(e.target.value)} required style={styles.input} disabled={cargando} />
          <input type="password" placeholder="Contraseña" autoComplete="current-password" value={password} onChange={(e) => setPassword(e.target.value)} required style={styles.input} disabled={cargando} />
          <button type="submit" style={styles.button} disabled={cargando}>{cargando ? "Cargando..." : "Entrar"}</button>
        </form>
        {error && <p role="alert" style={styles.message}>{`❌ ${error}`}</p>}
      </div>
    </div>
  );
}

// Mismo formato que el login de la app de compras (solo cambia el logo).
const styles = {
  fondo: { minHeight: "100vh", background: "#fff", padding: "1px 12px", boxSizing: "border-box" },
  container: { maxWidth: 400, margin: "50px auto", padding: 30, borderRadius: 8, boxShadow: "0 0 10px rgba(0,0,0,0.1)", fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif", backgroundColor: "#fff" },
  logo: { display: "block", width: 160, height: 160, borderRadius: 28, margin: "0 auto 20px" },
  title: { textAlign: "center", marginBottom: 20, color: "#333" },
  form: { display: "flex", flexDirection: "column" },
  input: { padding: 12, marginBottom: 15, borderRadius: 4, border: "1px solid #ccc", fontSize: 16 },
  button: { padding: 12, borderRadius: 4, border: "none", backgroundColor: "#007bff", color: "#fff", fontWeight: "bold", fontSize: 16, cursor: "pointer", transition: "background-color 0.3s ease" },
  message: { marginTop: 20, textAlign: "center", fontWeight: "bold" },
};
